import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import { PageInfoFragmentDoc } from '../../../graphql/fragments/PageInfo.generated';
import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowRulesQueryVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  workflowRulesInputObjectFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesInputObjectFiltersInput>;
  workflowRulesOutputObjectFiltersInput?: GraphQLTypes.InputMaybe<GraphQLTypes.WorkflowRulesOutputObjectFiltersInput>;
}>;

export type GetWorkflowRulesQueryResult = { __typename?: 'Query' } & {
  workflowRules?: GraphQLTypes.Maybe<
    { __typename?: 'WorkflowRuleConnection' } & Pick<GraphQLTypes.WorkflowRuleConnection, 'totalCount'> & {
        nodes: Array<
          GraphQLTypes.Maybe<
            { __typename?: 'WorkflowRuleType' } & Pick<GraphQLTypes.WorkflowRuleType, 'id'> & {
                ruleDefinition: { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
                  GraphQLTypes.WorkflowRuleDefinitionType,
                  'id'
                > & {
                    ruleInputFields: Array<
                      { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'name'>
                    >;
                    ruleOutputFields: Array<
                      { __typename?: 'WorkflowRuleFieldType' } & Pick<GraphQLTypes.WorkflowRuleFieldType, 'name'>
                    >;
                  };
                ruleInput: { __typename?: 'RuleInputObjectType' } & Pick<
                  GraphQLTypes.RuleInputObjectType,
                  | 'collectionCountry'
                  | 'countryOfDestination'
                  | 'countryOfOrigin'
                  | 'deliveryCountry'
                  | 'destination'
                  | 'incoterms'
                  | 'modeOfTransport'
                  | 'origin'
                  | 'portOfDestination'
                  | 'portOfDestinationCountry'
                  | 'portOfOrigin'
                  | 'portOfOriginCountry'
                  | 'shipmentContext'
                  | 'shipmentType'
                > & {
                    account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'tradingName'>>;
                    event?: GraphQLTypes.Maybe<
                      Array<
                        GraphQLTypes.Maybe<
                          { __typename?: 'UserDefinedEventType' } & Pick<GraphQLTypes.UserDefinedEventType, 'name'>
                        >
                      >
                    >;
                    supplier?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'tradingName'>>;
                  };
                ruleOutput: { __typename?: 'RuleOutputObjectType' } & {
                  actions?: GraphQLTypes.Maybe<
                    Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>
                  >;
                  consignee?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountLocation' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  consignor?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountLocation' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  customerOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  customsOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  destinationOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  notifyParties?: GraphQLTypes.Maybe<
                    Array<
                      { __typename?: 'AccountLocation' } & {
                        label?: GraphQLTypes.Maybe<
                          { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                        >;
                      }
                    >
                  >;
                  originAgent?: GraphQLTypes.Maybe<
                    { __typename?: 'Account' } & {
                      label?: GraphQLTypes.Maybe<
                        { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
                      >;
                    }
                  >;
                  originOperationsCoordinator?: GraphQLTypes.Maybe<
                    { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'firstName' | 'lastName'>
                  >;
                  supplierContacts?: GraphQLTypes.Maybe<
                    Array<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'email' | 'firstName' | 'lastName'>>
                  >;
                };
              }
          >
        >;
        pageInfo: { __typename: 'PageInfo' } & Pick<
          GraphQLTypes.PageInfo,
          'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'
        >;
      }
  >;
};

export const GetWorkflowRulesDocument = /*#__PURE__*/ gql`
  query getWorkflowRules(
    $workflowRuleDefinitionId: String!
    $after: String
    $before: String
    $first: Int
    $last: Int
    $workflowRulesInputObjectFiltersInput: WorkflowRulesInputObjectFiltersInput
    $workflowRulesOutputObjectFiltersInput: WorkflowRulesOutputObjectFiltersInput
  ) {
    workflowRules(
      workflowRuleDefinitionId: $workflowRuleDefinitionId
      after: $after
      before: $before
      first: $first
      last: $last
      workflowRulesInputObjectFiltersInput: $workflowRulesInputObjectFiltersInput
      workflowRulesOutputObjectFiltersInput: $workflowRulesOutputObjectFiltersInput
    ) {
      nodes {
        id
        ruleDefinition {
          id
          ruleInputFields {
            name
          }
          ruleOutputFields {
            name
          }
        }
        ruleInput {
          account {
            tradingName
          }
          collectionCountry
          countryOfDestination
          countryOfOrigin
          deliveryCountry
          destination
          event {
            name
          }
          incoterms
          modeOfTransport
          origin
          portOfDestination
          portOfDestinationCountry
          portOfOrigin
          portOfOriginCountry
          shipmentContext
          shipmentType
          supplier {
            tradingName
          }
        }
        ruleOutput {
          actions {
            label
            path
            type
          }
          consignee {
            label {
              long
              short
            }
          }
          consignor {
            label {
              long
              short
            }
          }
          customerOperationsCoordinator {
            firstName
            lastName
          }
          customsOperationsCoordinator {
            firstName
            lastName
          }
          destinationOperationsCoordinator {
            firstName
            lastName
          }
          notifyParties {
            label {
              long
              short
            }
          }
          originAgent {
            label {
              long
              short
            }
          }
          originOperationsCoordinator {
            firstName
            lastName
          }
          supplierContacts {
            email
            firstName
            lastName
          }
        }
      }
      pageInfo {
        ...PageInfo
      }
      totalCount
    }
  }
  ${PageInfoFragmentDoc}
`;

/**
 * __useGetWorkflowRulesQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRulesQuery({
 *   variables: {
 *      workflowRuleDefinitionId: // value for 'workflowRuleDefinitionId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      workflowRulesInputObjectFiltersInput: // value for 'workflowRulesInputObjectFiltersInput'
 *      workflowRulesOutputObjectFiltersInput: // value for 'workflowRulesOutputObjectFiltersInput'
 *   },
 * });
 */
export function useGetWorkflowRulesQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables>(GetWorkflowRulesDocument, options);
}
export function useGetWorkflowRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowRulesQueryResult, GetWorkflowRulesQueryVariables>(GetWorkflowRulesDocument, options);
}
export type GetWorkflowRulesQueryHookResult = ReturnType<typeof useGetWorkflowRulesQuery>;
export type GetWorkflowRulesLazyQueryHookResult = ReturnType<typeof useGetWorkflowRulesLazyQuery>;
